import { useQuery } from "@tanstack/react-query";
import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { areaApi, areaApiGet } from "../../../../API/areaApi/areaApi";
import { refetching } from "../../../../API/reFeatch";

import { ConvertEnglish } from "../../../../components/ConterEnglsih";
import { GStore } from "../../../../context/Context";
import { FETCHING_ERROR, FETCHING_OF, FETCHING_REFETCH, FETCHING_START, FETCHING_SUCCESS_ARES } from "../../../../state/actionTypes/actionTypes";
import LoadingPage from "../../../sheard/LoadingPage";
import { webTittle } from "../../../sheard/webTittle";
import AddAreaModal from "../AddAreaModal/AddAreaModal";

const Area = () => {
  webTittle("এরিয়া")
  const { register, handleSubmit, reset } = useForm();
  const { english, state ,dispatch,  } = useContext(GStore);
  const {areas : areasData,loading } = state;
  // console.log(state);
  const handleAddArea = async (data) => {
   dispatch({type : FETCHING_SUCCESS_ARES, payload : [...state.areas,data]});
    // console.log(data);
    areaApi(data,);
    reset();
  
  };

 

  return (
    <div className="mx-2">
      <div className="flex justify-between items-center">
        <h2 className="text-3xl m-5 font-bold ">
          <ConvertEnglish english={"Area"} bangla={"এরিয়া"} />
        </h2>
        <label
          htmlFor="add-area-modal"
          className="btn btn-outline text-1xl m-5 font-bold "
        >
          <ConvertEnglish english={"Add Area"} bangla={"সংযোগ এরিয়া"} />
        </label>
      </div>
      <div className=" flex justify-center items-center">
        <table className="table w-[100%]  text-center">
          {/* <!-- head --> */}
          <thead>
            <tr>
              <th>
                <ConvertEnglish english={"Area Name"} bangla={"এরিয়া নাম"} />
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {/* <!-- row 1 --> start*/}

          {
            loading ?<LoadingPage></LoadingPage> : <>
            {areasData &&
              areasData.map((areaData) => (
                <tr key={areaData._id} className="border-b">
                  <td>
                    <p>{areaData.area}</p>
                  </td>
                  <td>
                      <div className="dropdown dropdown-left">
                        <label tabIndex={0} className="cursor-pointer m-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            className="inline-block w-5 h-5 stroke-current"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                            ></path>
                          </svg>
                        </label>
                        <ul
                          tabIndex={0}
                          className="dropdown-content menu p-2 shadow bg-base-100 rounded-box "
                        >
                          <li>
                            <a>Item 1</a>
                          </li>
                          <li>
                            <a>Item 2</a>
                          </li>
                        </ul>
                      </div>
                    </td>
                </tr>
              ))}
            </>
          }

          
            {/* <!-- row 1 --> end*/}
          </tbody>
        </table>
      </div>
      <AddAreaModal
      loading={loading}
        handleAddArea={handleAddArea}
        register={register}
        handleSubmit={handleSubmit}
      ></AddAreaModal>
    </div>
  );
};

export default Area;
